import * as React from 'react';
import MediaQuery from 'react-responsive';
import { debounce } from '@telia-front/helper';
import Icon from '@telia-front/icon';
import { InputContext } from '@telia-front/input-provider';
import { useTheme } from '@telia-front/theme-provider';
import HeaderDropdown from '../header-dropdown/header-dropdown';
import HeaderMegamenu from '../header-megamenu/header-megamenu';
const HeaderNavItem = (props) => {
    const { media } = useTheme();
    const { input } = React.useContext(InputContext);
    return React.createElement(HeaderNavItemInner, Object.assign({}, props, { media: media, input: input }));
};
export default HeaderNavItem;
class HeaderNavItemInner extends React.PureComponent {
    constructor(props) {
        super(props);
        this.labelElement = null;
        this.linkRef = React.createRef();
        this.dropdown = null;
        this.hoverTimeout = 0;
        this.handleResize = () => {
            if (this.labelElement) {
                this.resetItemStyle();
            }
        };
        this.triggerItemOnLoad = (event) => {
            if (this.linkRef && this.linkRef.current && this.props.input === 'mouse') {
                const linkElementRect = this.linkRef.current.getBoundingClientRect();
                const cursorX = event.pageX;
                const cursorY = event.pageY;
                if (cursorX >= linkElementRect.left && cursorX <= linkElementRect.right && cursorY >= linkElementRect.top && cursorY <= linkElementRect.bottom) {
                    if (this.props.onToggle) {
                        this.props.onToggle(true);
                    }
                }
            }
        };
        this.handleDropdownMouseLeave = (event) => {
            event.persist();
            window.clearTimeout(this.hoverTimeout);
            this.hoverTimeout = window.setTimeout(() => {
                if (this.linkRef.current && this.linkRef.current.matches(':hover')) {
                    return;
                }
                if (this.dropdown && this.dropdown.matches(':hover')) {
                    return;
                }
                if (this.props.isOpen) {
                    if (this.props.onToggle) {
                        this.props.onToggle(false);
                    }
                }
            }, 300);
        };
        this.handleMouseLeave = (event) => {
            event.persist();
            window.clearTimeout(this.hoverTimeout);
            this.hoverTimeout = window.setTimeout(() => {
                if (this.dropdown && this.dropdown.matches(':hover')) {
                    return;
                }
                if (this.linkRef.current && this.linkRef.current.matches(':hover')) {
                    return;
                }
                if (this.props.isOpen) {
                    if (this.props.onToggle) {
                        this.props.onToggle(false);
                    }
                }
            }, 300);
        };
        this.handleMouseEnter = (event) => {
            event.persist();
            window.clearTimeout(this.hoverTimeout);
            this.hoverTimeout = window.setTimeout(() => {
                if (!this.props.isOpen) {
                    if (this.props.onToggle) {
                        this.props.onToggle(true);
                    }
                }
            }, 100);
        };
        this.handleMediaQueryChange = (matches) => {
            this.setState({
                isLargeScreen: matches,
            });
        };
        this.handleKeyDown = (event) => {
            if (this.props.children) {
                switch (event.key) {
                    case 'Enter':
                    case ' ': {
                        // toggle dropdown visiblity with enter and space
                        event.preventDefault();
                        if (this.props.onToggle) {
                            this.props.onToggle(!this.props.isOpen);
                        }
                        break;
                    }
                    case 'Escape': {
                        // escaping, should close dropdown
                        event.preventDefault();
                        if (this.props.onToggle) {
                            this.props.onToggle(false);
                        }
                        break;
                    }
                }
            }
        };
        this.handleDropdownKeyDown = (event) => {
            var _a;
            if (this.props.children && this.props.isOpen) {
                switch (event.key) {
                    case 'Escape': {
                        // escaping, should close dropdown and focus reference
                        event.preventDefault();
                        if (this.props.onToggle) {
                            this.props.onToggle(false);
                        }
                        (_a = this.linkRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        break;
                    }
                }
            }
        };
        this.handleClick = (event) => {
            event.preventDefault();
            if (!this.shouldUseHover) {
                if (this.props.onToggle) {
                    this.props.onToggle(!this.props.isOpen);
                }
            }
            if (this.props.onClick) {
                this.props.onClick(event);
            }
        };
        this.debouncedResizeHandler = debounce(this.handleResize, 100);
        this.state = {
            isLargeScreen: false,
            isMounted: false,
            itemStyle: { minWidth: '1px' }, // Some existing width is necessary for cross-browser support.
        };
    }
    componentDidMount() {
        this.setItemStyle();
        this.setState({
            isLargeScreen: window.matchMedia(`(min-width: ${this.props.media.width.lg.min})`).matches,
            isMounted: true,
        });
        if (this.props.children) {
            window.addEventListener('mousemove', this.triggerItemOnLoad, {
                once: true,
            });
        }
        window.addEventListener('resize', this.debouncedResizeHandler);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.label !== this.props.label && this.labelElement) {
            this.resetItemStyle();
        }
    }
    get shouldUseHover() {
        return this.props.input === 'mouse' && this.state.isLargeScreen;
    }
    setItemStyle() {
        if (this.labelElement) {
            this.setState({
                itemStyle: {
                    minWidth: `${this.labelElement.scrollWidth}px`,
                },
            });
        }
    }
    resetItemStyle() {
        this.setState({
            itemStyle: { minWidth: '1px' },
        }, () => {
            this.setItemStyle();
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.hoverTimeout);
        window.removeEventListener('resize', this.debouncedResizeHandler);
        this.debouncedResizeHandler.clear();
    }
    BEM() {
        const classArray = ['header__nav-item'];
        if (this.props.isCurrent) {
            classArray.push('is-current');
            if (this.props.children) {
                classArray.push('has-submenu');
            }
        }
        if (this.props.isOpen) {
            classArray.push('is-open');
        }
        return classArray.join(' ');
    }
    linkBEM() {
        const classArray = ['header__nav-link'];
        if (this.props.color) {
            classArray.push('header__nav-link--' + this.props.color);
        }
        return classArray.join(' ');
    }
    secondaryIconBEM() {
        const classArray = ['header__nav-secondary-icon'];
        if (this.props.secondaryIconPurpose) {
            classArray.push(this.props.secondaryIconPurpose);
        }
        return classArray.join(' ');
    }
    renderSecondaryIcon() {
        if (this.props.secondaryIcon) {
            return React.createElement(Icon, { modifiers: this.props.secondaryIcon, className: this.secondaryIconBEM() });
        }
        return null;
    }
    renderMegamenuDropdown(megamenu) {
        return (React.createElement(HeaderDropdown, { className: "header__nav-megamenu-dropdown", padding: "medium", reference: this.linkRef.current, container: this.props.dropdownContainer || null, elementRef: element => (this.dropdown = element), onMouseLeave: this.shouldUseHover ? this.handleDropdownMouseLeave : undefined, isShown: this.props.isOpen || false, onTransitionExited: this.props.onMegamenuDropdownTransitionExited, onTransitionEntered: this.props.onMegamenuDropdownTransitionEntered, id: `${this.props.id}-megamenu-dropdown`, onKeyDown: this.handleDropdownKeyDown, fullWidth: true }, this.renderMegamenu(megamenu, this.linkRef.current, true)));
    }
    renderMegamenu(megamenu, ref, setId = false) {
        return React.createElement(HeaderMegamenu, Object.assign({}, megamenu, { className: "header__nav-megamenu", id: setId ? `${this.props.id}-megamenu` : undefined, reference: ref }));
    }
    renderDropdownOrMegamenu(ref) {
        const { children } = this.props;
        if (children) {
            if (this.state.isLargeScreen && this.props.dropdownContainer) {
                return this.renderMegamenuDropdown(children);
            }
            return this.renderMegamenu(children, ref, true);
        }
        return null;
    }
    render() {
        return (React.createElement("li", { className: this.BEM(), style: this.state.itemStyle },
            React.createElement("a", { href: this.props.url, onClick: this.props.children ? this.handleClick : this.props.onClick, onMouseEnter: this.shouldUseHover ? this.handleMouseEnter : undefined, onMouseLeave: this.shouldUseHover ? this.handleMouseLeave : undefined, onKeyDown: this.handleKeyDown, className: this.linkBEM(), ref: this.linkRef, "aria-controls": this.state.isMounted && this.props.children && this.props.isOpen ? `${this.props.id}-megamenu` : undefined, "aria-expanded": this.state.isMounted && this.props.children ? (this.props.isOpen ? 'true' : 'false') : undefined, "aria-current": this.props.isCurrent ? (this.props.children ? true : 'page') : undefined, role: this.state.isMounted && this.props.children ? 'button' : undefined },
                this.props.icon && React.createElement(Icon, { modifiers: this.props.icon, className: "header__nav-icon" }),
                React.createElement("div", { className: "header__nav-label" },
                    React.createElement("span", { className: "header__nav-label-inner", ref: element => (this.labelElement = element) },
                        this.state.isMounted && !this.state.isLargeScreen && this.props.mobileLabel ? this.props.mobileLabel : this.props.label,
                        this.renderSecondaryIcon())),
                this.props.children && React.createElement(Icon, { modifiers: "#arrow-down", className: "header__nav-arrow" })),
            this.linkRef.current && this.renderDropdownOrMegamenu(this.linkRef.current),
            this.state.isMounted && (React.createElement(MediaQuery, { minWidth: this.props.media.width.lg.min, onChange: this.handleMediaQueryChange }, null))));
    }
}
